import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Api from "../../../Helper/ApiHandler";
const api = new Api();

const BarCharts = ({ selectedDate }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      const requestBody = {
        endDate: selectedDate,
      };
      const data = await api.post(`${"dashboard/new-user"}`, requestBody);
      setData(data.data);
    })();
  }, [selectedDate]);
  if (!data.length) return null;

  function formatTick(value) {
    // Round the value to the nearest integer

    if (Number.isInteger(value)) {
      return value;
    }
    return "";
  }

  return (
    <ResponsiveContainer>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          bottom: 10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="_id" />
        <YAxis tickFormatter={formatTick} />
        <Tooltip />
        <Legend />
        <Bar dataKey="user" fill="#4FD1C5" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarCharts;
